import { useI18n } from '../contexts/I18nContext';
import { ElasticGallery, type ElasticItemProps } from '../components/ui/elastic-gallery';
import client1 from '../assets/clients/client-1.jpeg';
import client2 from '../assets/clients/client-2.jpeg';
import client3 from '../assets/clients/client-3.jpeg';
import client4 from '../assets/clients/client-4.jpeg';
import client5 from '../assets/clients/client-5.jpeg';
import client6 from '../assets/clients/client-6.jpeg';
import client7 from '../assets/clients/client-7.jpeg';

const clientImages = [client1, client2, client3, client4, client5, client6, client7];

export default function OurClientsSection() {
  const { t } = useI18n();

  const items: ElasticItemProps[] = t.ourClients.items.map((item, index) => ({
    id: String(index + 1).padStart(2, '0'),
    title: item.title,
    category: item.category,
    src: clientImages[index],
    alt: item.alt,
  }));

  return (
    <section className="relative py-16 md:py-24 bg-gradient-to-b from-white via-[#F8F5FF] to-white overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-4 md:mb-8">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#5B3FD0]/10 bg-white shadow-sm mb-6">
            <div className="w-2 h-2 bg-[#9FFFCB] rounded-full animate-pulse"></div>
            <span className="text-sm font-bold text-[#5B3FD0] uppercase tracking-wider">
              {t.ourClients.badge}
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#2C2C2C] mb-4">
            {t.ourClients.title}
          </h2>
          <p className="text-lg text-[#707070] leading-relaxed">
            {t.ourClients.intro}
          </p>
        </div>
      </div>

      <ElasticGallery items={items} className="py-8 md:py-12" />
    </section>
  );
}
